var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 4,
    fill: "#9D4EDD",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1222_6792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.68965 20.2621C10.6627 20.2621 11.4516 19.4733 11.4516 18.5002C11.4516 17.5271 10.6627 16.7383 9.68965 16.7383C8.71657 16.7383 7.92773 17.5271 7.92773 18.5002C7.92773 19.4733 8.71657 20.2621 9.68965 20.2621Z",
    fill: "#9D4EDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4983 20.2621C19.4713 20.2621 20.2602 19.4733 20.2602 18.5002C20.2602 17.5271 19.4713 16.7383 18.4983 16.7383C17.5252 16.7383 16.7363 17.5271 16.7363 18.5002C16.7363 19.4733 17.5252 20.2621 18.4983 20.2621Z",
    fill: "#9D4EDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3088 20.2621C28.2819 20.2621 29.0707 19.4733 29.0707 18.5002C29.0707 17.5271 28.2819 16.7383 27.3088 16.7383C26.3357 16.7383 25.5469 17.5271 25.5469 18.5002C25.5469 19.4733 26.3357 20.2621 27.3088 20.2621Z",
    fill: "#9D4EDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1222_6792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.1429,
    height: 21.1429,
    fill: "white",
    transform: "translate(7.92773 7.92871)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsHorizontal);
export default __webpack_public_path__ + "static/media/dots-horizontal.dd78d795710ef0f53ecbd7e0889f8653.svg";
export { ForwardRef as ReactComponent };